import { MenuItem, Select } from '@mui/material';
import { LotStatus } from '../../../../constants/search.ts';

interface LotStatusDropdownProps {
  lotStatus: LotStatus | undefined;
  onLotStatusChange: (event: LotStatus | undefined) => void;
}

export const LotStatusDropdown = ({
  lotStatus,
  onLotStatusChange,
}: LotStatusDropdownProps) => {
  return (
    <Select
      data-lot-status-dropdown
      labelId="lot-status-label"
      value={lotStatus ?? ''}
      variant="filled"
      onChange={(event) =>
        // "" should be interpreted as undefined
        onLotStatusChange(
          (event.target.value || undefined) as LotStatus | undefined
        )
      }
    >
      <MenuItem value="">
        <em>None</em>
      </MenuItem>
      <MenuItem value={'For Sale'}>For Sale (not under contract)</MenuItem>
      <MenuItem value={'Include Pending'}>Include Pending</MenuItem>
      <MenuItem value={'Sold'}>Sold in the Last 36 Months</MenuItem>
    </Select>
  );
};
